module.exports = __webpack_public_path__ + "img/logo-white.c35c5247.svg";